import { useCallback } from 'react'
import { useQuery } from '@apollo/client'
import { forwardRef, Select, SelectProps } from '@chakra-ui/react'
import { graphql } from '@/__generated__/gql'

type Props = {
  prompt?: string
  value: string | null
  onChange: (value: string | null) => void
} & Omit<SelectProps, 'value' | 'onChange'>

const invoiceProductsDocument = graphql(`
  query InvoiceProductSelect {
    invoiceProducts {
      results {
        id
        name
      }
    }
  }
`)

export const InvoiceProductSelect = forwardRef(
  ({ prompt, value, onChange, ...rest }: Props, ref) => {
    const { data, error } = useQuery(invoiceProductsDocument)
    const products = data?.invoiceProducts.results || []

    const handleChange = useCallback(
      (e: React.ChangeEvent<HTMLSelectElement>) => {
        onChange?.(e.target.value || null)
      },
      [onChange]
    )

    if (error) throw error

    return (
      <Select ref={ref} value={value ?? ''} onChange={handleChange} {...rest}>
        {prompt && <option>{prompt}</option>}
        {products.map((product) => (
          <option key={product.id} value={product.id}>
            {product.name}
          </option>
        ))}
      </Select>
    )
  }
)
